import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useFeatureAccessInsights } from '../featureAccessInsights';

export const useIsMyInsightsEntryPointVisible = (): boolean => {
  const isVivaEngagePremium = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;
  const featureAccessInsights = useFeatureAccessInsights();

  return isVivaEngagePremium && featureAccessInsights?.canViewActivity === true;
};
